import { ClientsRequest, HiveRequest } from 'client/features/client/actions'
import { fork, put } from 'redux-saga/effects'
import RequestSagas from 'client/core/RequestSagas'
import URLS from 'constant/URLS'
import { browserHistory } from 'react-router'
import { makeEndpoint } from 'client/core/api'
import { flash } from 'client/features/flashes/actions'

/*Fetch clients*/
export const getClientsSaga = new RequestSagas(ClientsRequest.get, { method: 'GET', endpoint: URLS.client.get })
getClientsSaga.success = function* (action) {
    
}
getClientsSaga.failure = function* (action) {
    
}

/*New client*/
export const postClientsSaga = new RequestSagas(ClientsRequest.post, { method: 'POST', endpoint: URLS.client.new })
postClientsSaga.success = function* (action) {
    browserHistory.push(makeEndpoint(URLS.client.show, action.payload.client))
}
postClientsSaga.failure = function* (action) {
    
}

/*Update client*/
export const putClientsSaga = new RequestSagas(ClientsRequest.put, { method: 'PUT', endpoint: URLS.client.update })
putClientsSaga.success = function* (action) {
    yield put(flash({ content: {
        type: 'success',
        title: 'Client modifié.'
    } }))
}
putClientsSaga.failure = function* (action) {
    
}

/*Delete client*/
export const deleteClientsSaga = new RequestSagas(ClientsRequest.delete, { method: 'DELETE', endpoint: URLS.client.update })
deleteClientsSaga.success = function* (action) {
    yield put(ClientsRequest.get.action())
}
deleteClientsSaga.failure = function* (action) {
    
}
/*New hive*/
export const postHiveSaga = new RequestSagas(HiveRequest.post, { method: 'POST', endpoint: URLS.client.newHive })
postHiveSaga.success = function* (action) {

}
postHiveSaga.failure = function* (action) {

}
/*Update hive*/
export const putHiveSaga = new RequestSagas(HiveRequest.put, { method: 'PUT', endpoint: URLS.client.updateHive })
putHiveSaga.success = function* (action) {
    yield put(flash({ content: {
        type: 'success',
        title: 'Ruche modifiée.'
    } }))
}
putHiveSaga.failure = function* (action) {

}

export const deleteHiveSaga = new RequestSagas(HiveRequest.delete, { method: 'DELETE', endpoint: URLS.client.updateHive })
deleteHiveSaga.success = function* (action) {
    yield put(ClientsRequest.get.action())
    yield put(flash({ content: {
        type: 'success',
        title: 'Ruche supprimée.'
    } }))
}
deleteHiveSaga.failure = function* (action) {

}

/*Export watchers sagas*/
const sagas = [
    fork(getClientsSaga.saga),
    fork(postClientsSaga.saga),
    fork(putClientsSaga.saga),
    fork(postHiveSaga.saga),
    fork(putHiveSaga.saga),
    fork(deleteClientsSaga.saga),
    fork(deleteHiveSaga.saga)
]

export default sagas


// WEBPACK FOOTER //
// ./src/client/features/client/sagas.js